export enum RequestIncidenceType {
    OPERATIONAL = "operational",
    ORGANISM = "organism",
}
